export enum CognitoErrorType {
  PasswordResetRequiredException = 'PasswordResetRequiredException',
  PasswordSetNewPasswordException = 'PasswordSetNewPasswordException',
  EmailVerificationException = 'EmailVerificationException',
  NotAuthorizedException = 'NotAuthorizedException'
}
